import script from "./ClassroomError.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassroomError.vue?vue&type=script&setup=true&lang=js"

import "./ClassroomError.vue?vue&type=style&index=0&id=1acf0ac4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1acf0ac4"]])

export default __exports__